// extracted by mini-css-extract-plugin
export default {"container":"SelfBillingExpenseListItemOverview_container__8ZLOa","col":"SelfBillingExpenseListItemOverview_col__y88oS","tag":"SelfBillingExpenseListItemOverview_tag__XBSpW"};